import Vue from "vue";
import App from "./App.vue";
import VueGlobalVar from "vue-global-var";
import vuetify from "./plugins/vuetify";
import router from "./router";
import "./styles.sass";
import VueExpandableImage from "vue-expandable-image";
import EventBus from "./event-bus";
import axios from "axios";
import VCurrencyField from "v-currency-field";
import { VTextField } from "vuetify/lib";

Vue.config.productionTip = false;

Vue.use(VueExpandableImage);

Vue.prototype.$bus = EventBus;

Vue.component("v-text-field", VTextField);
Vue.use(VCurrencyField, {
  locale: "id-ID",
  decimalLength: 0,
  autoDecimalMode: false,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: true,
  allowNegative: false,
});

Vue.use(VueGlobalVar, {
  globals: {
    $api: "https://dev-api-ppdb.smkruskudus.com/api/v2",
    $storage: "https://dev-api-ppdb.smkruskudus.com/storage",
    $date: [
      {
        open: "2023-10-16",
        close: "2023-12-30",
        test: "2024-01-06",
        result: "2024-01-15",
        wave: 1,
      },
      {
        open: "2030-02-27",
        close: "2030-05-06",
        test: "2030-05-16",
        result: "2030-05-28",
        wave: 2,
      },
      {
        open: "2030-06-12",
        close: "2030-06-17",
        test: "2030-06-19",
        result: "2030-06-23",
        wave: 3,
      },
      {
        open: "2040-07-01",
        close: "2040-07-01",
        test: "2040-07-01",
        result: "2040-07-01",
        wave: 4,
      },
    ],
  },
});

Vue.mixin({
  mounted() {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
  },
});

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
